function f(r, u) {
  const n = u ?? 0;
  return Array.isArray(r) ? r[n] ? r[n] : r[0] ? r[0] : "" : r || "";
}
export {
  f as getItemTextColor
};
